import React from 'react'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'
import { Button, Box, Input, Alert } from '@smooth-ui/core-sc'
import useInputValue from '@rehooks/input-value'
import { Search as SearchIcon } from 'styled-icons/fa-solid/Search'

import PageWrapper from 'components/PageWrapper/PageWrapper'
import ListView, { fragment } from 'components/ListView/ListView'
import { PageTitle } from 'components/Elements/index'
import { LoadingSpinnerFullscreen } from 'components/Spinner/Spinner'

import routeConfig from 'routeConfig'

const name = 'Søk etter treningsvideor'

const Search = ({
  match: {
    params: { phrase, after },
    url
  },
  history: { push }
}) => {
  const textField = useInputValue(phrase || '')
  const onSubmit = event => {
    event.preventDefault()
    push(`${routeConfig.search}/${textField.value}`)
  }
  return (
    <PageWrapper title={name}>
      <PageTitle>{name}</PageTitle>
      <Box as="form" onSubmit={onSubmit} mb={2} display="flex">
        <Input
          {...textField}
          placeholder="Søk etter treningsvideor"
          flex="1"
          mr="0.5rem"
          display="inline-block"
        />
        <Button px={{ sm: '2rem' }}>
          <SearchIcon size={16} /> Søk
        </Button>
      </Box>
      {phrase && <SearchQuery phrase={phrase} after={after} url={url} />}
    </PageWrapper>
  )
}

const SearchQuery = ({ phrase, after, url }) => {
  const { data, loading } = useQuery(query, {
    variables: {
      first: 9,
      after,
      phrase
    }
  })
  return (
    <>
      {loading && !data && <LoadingSpinnerFullscreen />}
      {data && !!data.posts.nodes.length && (
        <ListView
          {...data.posts}
          baseUrl={`${routeConfig.search}${phrase ? `/${phrase}` : ''}`}
          after={after}
          backState={{ fromUrl: url, fromName: name }}
        />
      )}
      {data && data.posts.nodes.length === 0 && (
        <Alert>Ingen treningsvideor funnet på "{phrase}"</Alert>
      )}
    </>
  )
}

const query = gql`
  query PostSearch($first: Int!, $after: String, $phrase: String) {
    posts(first: $first, after: $after, where: { search: $phrase }) {
      ...PostList
    }
  }
  ${fragment}
`

export default Search
